export enum AccessControlContactInformationEnum {
    CLIENT = 'client',
    CONTRACT = 'contract'
}
